import salesdata from '../components/views/Salesdata/salesdata.vue'
import SalesdataCreate from '../components/views/Salesdata/SalesdataCreate.vue'
import SalesdataDetails from '../components/views/Salesdata/SalesdataDetails.vue'

const routes = [{
        path: 'sales_settings',
        component: salesdata,
        name: 'salesdata',
        meta: {
            title: 'Sales Status',
            requiresAuth: true
        }
    },

    {
        path: 'sales_settings/create',
        component: SalesdataCreate,
        name: 'salesdataCreate',
        meta: {
            description: 'Daily Sales Status Report',
            title: 'Add Sales Status',
            requiresAuth: true
        }
    },
    {
        path: '/sales_settings/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'salesdataCreate' }) : next()
        },
        component: SalesdataDetails,
        name: 'SalesdataDetails',
        meta: {
            description: 'Daily Sales Status Report',
            title: 'Update Sales Status',
            requiresAuth: true
        }
    },


]

export default routes


// WEBPACK FOOTER //
// ./src/routes/salesdata.route.js